<script lang="ts">
  import { onMount } from 'svelte';
  import gsap from 'gsap';
  import Header from './components/Header.svelte';
  import Hero from './components/Hero.svelte';
  import Features from './components/Features.svelte';
  import Pricing from './components/Pricing.svelte';
  import Footer from './components/Footer.svelte';
  import Eye from './components/Eye.svelte';
  
  let isBlind = false;
  let mouseX = 0;
  let mouseY = 0;
  
  // Обработчик движения мыши для отслеживания глазом
  function handleMouseMove(event: MouseEvent) {
    mouseX = event.clientX;
    mouseY = event.clientY;
  }
  
  // Функция для переключения режима VPN (слепой глаз/зрячий глаз)
  function toggleVPN() {
    isBlind = !isBlind;
    
    if (isBlind) {
      // Анимация перехода в режим Шира (зеленый, спокойный)
      document.body.classList.remove('mordor-mode');
      document.body.classList.add('shire-mode');
      gsap.to('body', { backgroundColor: 'var(--shire-light)', color: '#333', duration: 1 });
    } else {
      // Анимация перехода в режим Мордора (темный, огненный)
      document.body.classList.remove('shire-mode');
      document.body.classList.add('mordor-mode');
      gsap.to('body', { backgroundColor: 'var(--mordor-dark)', color: '#fff', duration: 1 });
    }
  }
  
  onMount(() => {
    // Инициализация режима Мордора при загрузке
    document.body.classList.add('mordor-mode');
    
    // Прослушиваем движение мыши
    window.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      // Очищаем слушатель при размонтировании компонента
      window.removeEventListener('mousemove', handleMouseMove);
    };
  });
</script>

<svelte:window on:mousemove={handleMouseMove}/>

<div class="app-container">
  <!-- Глаз Саурона, который следит за курсором -->
  <Eye {mouseX} {mouseY} {isBlind} />
  
  <Header />
  
  <main>
    <Hero {toggleVPN} {isBlind} />
    <Features />
    <Pricing />
  </main>
  
  <Footer />
</div>

<style>
  .app-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    position: relative;
    overflow-x: hidden;
  }
  
  main {
    flex: 1;
  }
</style> 